import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { validateEmail } from '../../../utils/validators';
import { ROUTES } from '../../../config/constants';
import './ForgotPasswordForm.css';

const ForgotPasswordForm = () => {
    const navigate = useNavigate();
    const [formData, setFormData] = useState({
        email: '',
    });
    const [errors, setErrors] = useState({});
    const [loading, setLoading] = useState(false);
    const [success, setSuccess] = useState(false);

    const validateForm = () => {
        const newErrors = {};

        const emailValidation = validateEmail(formData.email);
        if (!emailValidation.isValid) {
            newErrors.email = emailValidation.error;
        }

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));

        // Clear error for this field
        if (errors[name]) {
            setErrors(prev => ({
                ...prev,
                [name]: ''
            }));
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!validateForm()) {
            return;
        }

        setLoading(true);

        try {
            // Hier würde die API-Anfrage für Passwort-Reset erfolgen
            // const result = await requestPasswordReset(formData);
            
            // Simuliere API-Aufruf
            await new Promise(resolve => setTimeout(resolve, 2000));
            
            setSuccess(true);
            setErrors({});
        } catch (err) {
            setErrors({ general: 'Ein Fehler ist aufgetreten. Bitte versuchen Sie es erneut.' });
        } finally {
            setLoading(false);
        }
    };

    const handleBackToLogin = () => {
        navigate(ROUTES.LOGIN || '/login');
    };

    const handleInitializePassword = () => {
        navigate('/init-password'); // Route für Passwort-Initialisierung
    };

    if (success) {
        return (
            <div className="forgot-password-form">
                <div className="success-message">
                    <h3>E-Mail wurde versendet!</h3>
                    <p>
                        Falls ein Konto mit dieser E-Mail-Adresse existiert, 
                        erhalten Sie in Kürze eine E-Mail mit Anweisungen 
                        zum Zurücksetzen Ihres Passworts.
                    </p>
                    <button
                        type="button"
                        className="submit-button"
                        onClick={handleBackToLogin}
                    >
                        Zurück zum Login
                    </button>
                </div>
            </div>
        );
    }

    return (
        <form onSubmit={handleSubmit} className="forgot-password-form">
            <div className="form-header">
                <h2>Passwort vergessen?</h2>
                <p>Geben Sie Ihre E-Mail-Adresse ein und wir senden Ihnen einen Link zum Zurücksetzen Ihres Passworts.</p>
            </div>

            <div className="form-group">
                <input
                    type="email"
                    name="email"
                    placeholder="E-Mail-Adresse"
                    value={formData.email}
                    onChange={handleChange}
                    className={errors.email ? 'error' : ''}
                />
                {errors.email && <span className="error-text">{errors.email}</span>}
            </div>

            {errors.general && (
                <div className="error-message">{errors.general}</div>
            )}

            <div className="form-actions">
                <button
                    type="button"
                    className="back-button"
                    onClick={handleBackToLogin}
                >
                    Zurück zum Login
                </button>

                <button
                    type="submit"
                    className="submit-button"
                    disabled={loading}
                >
                    {loading ? 'Wird gesendet...' : 'Link senden'}
                </button>
            </div>
        </form>
    );
};

export default ForgotPasswordForm;